import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

export default function VersionBadge() {
  const { data } = useQuery({
    queryKey: ['version'],
    queryFn: async () => {
      const response = await axios.get('/api/version')
      return response.data.version as string
    },
    staleTime: Infinity, // Version doesn't change during session
    retry: false,
  })

  if (!data) return null

  return (
    <div className="fixed top-4 right-4 z-50">
      <span className="px-2 py-1 text-xs font-mono bg-gray-800 text-gray-300 rounded">
        v{data}
      </span>
    </div>
  )
}
